










































import { defineComponent, reactive } from '@vue/composition-api'

import { UserRole } from '@/types/user'
import { BrandSkuState, UserState } from '@/types/store'

import useVuex from '@/utils/useVuex'

import Layout from '@/components/organisms/common/Layout.vue'
import { BrandSkusTable } from '@/components/organisms/brand-skus'

export default defineComponent({
  name: 'AdminBrandSkus',
  components: { Layout, BrandSkusTable },
  setup(props, context) {
    const store = context.root.$store
    const state = reactive({
      brandSkus: useVuex<BrandSkuState['brandSkus']>(
        context,
        () => store.getters['brandSku/brandSkus'],
      ),
      isBrandSkusLoading: useVuex<BrandSkuState['isBrandSkusLoading']>(
        context,
        () => store.getters['brandSku/isBrandSkusLoading'],
      ),
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
      name: '',
      code: '',
      categoryId: -1,
    })

    const search = async () => {
      try {
        await store.dispatch('brandSku/getBrandSkus', {
          name: state.name,
          code: state.code,
          categoryId: state.categoryId,
        })
      } catch (_) {
        store.dispatch('brandSku/reset')
        alert('タイムアウトしました。検索条件を変更して再度お試しください。')
      }
    }

    return { state, search, UserRole }
  },
})
